import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.tryon.angles');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-tryon-angles',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.tryon.angles/view.scss */
/* src/app/page.tryon.angles/view.scss: no such file or directory */`],
})
export class PageTryonAnglesComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public fitTabs: any[] = [
        { key: 'basic', label: '기본 피팅', path: '/tryon' },
        { key: 'angles', label: '다각도 피팅', path: '/tryon/angles' }
    ];
    public currentFitTab: string = 'angles';
    public currentModeQueryParams: any = { mannequin_mode: 'without' };
    public mannequinViews: any[] = [
        { key: 'angle-front', label: '정면' },
        { key: 'angle-left', label: '사선' },
        { key: 'angle-right', label: '측면' },
        { key: 'angle-back', label: '후면' }
    ];
    public genderOptions: any[] = [
        {
            key: 'female',
            label: '여성',
            shortLabel: '여',
            activeClass: 'border-rose-500 bg-rose-50 text-rose-800 ring-2 ring-rose-200 shadow-sm',
            inactiveClass: 'border-gray-200 bg-white text-gray-600 hover:border-rose-300 hover:bg-rose-50 hover:text-rose-700',
            activeBadgeClass: 'bg-rose-600 text-white',
            inactiveBadgeClass: 'bg-rose-50 text-rose-700 ring-1 ring-rose-200'
        },
        {
            key: 'male',
            label: '남성',
            shortLabel: '남',
            activeClass: 'border-sky-500 bg-sky-50 text-sky-800 ring-2 ring-sky-200 shadow-sm',
            inactiveClass: 'border-gray-200 bg-white text-gray-600 hover:border-sky-300 hover:bg-sky-50 hover:text-sky-700',
            activeBadgeClass: 'bg-sky-600 text-white',
            inactiveBadgeClass: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200'
        }
    ];
    public selectedGender: string = 'female';
    public expandedGarmentTypes: any = {
        upper: true,
        lower: false
    };
    public garmentSlots: any[] = [
        {
            key: 'upper',
            label: '상의',
            angles: [
                { key: 'angle-front', label: '정면', name: '', preview: '', file: null, objectUrl: '' },
                { key: 'angle-left', label: '사선', name: '', preview: '', file: null, objectUrl: '' },
                { key: 'angle-right', label: '측면', name: '', preview: '', file: null, objectUrl: '' },
                { key: 'angle-back', label: '후면', name: '', preview: '', file: null, objectUrl: '' }
            ]
        },
        {
            key: 'lower',
            label: '하의',
            angles: [
                { key: 'angle-front', label: '정면', name: '', preview: '', file: null, objectUrl: '' },
                { key: 'angle-left', label: '사선', name: '', preview: '', file: null, objectUrl: '' },
                { key: 'angle-right', label: '측면', name: '', preview: '', file: null, objectUrl: '' },
                { key: 'angle-back', label: '후면', name: '', preview: '', file: null, objectUrl: '' }
            ]
        }
    ];
    public resultItems: any[] = [];
    public generating: boolean = false;
    private generationVersions: any = {};
    private activeGenerations: number = 0;
    private readonly resultImageWidth: number = 750;
    private readonly resultImageHeight: number = 1000;

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnDestroy() {
        this.garmentSlots.forEach(slot => {
            (slot.angles || []).forEach(item => {
                if (item.objectUrl) URL.revokeObjectURL(item.objectUrl);
            });
        });
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public get currentFitLabel() {
        const tab = this.fitTabs.find(item => item.key === this.currentFitTab);
        return tab ? tab.label : '다각도 피팅';
    }

    public get shouldIgnoreMannequin() {
        return true;
    }

    private getGarmentSlot(type: string) {
        return this.garmentSlots.find(slot => slot.key === type);
    }

    private getAngleView(angle: string) {
        return this.mannequinViews.find(item => item.key === angle);
    }

    private getGarmentAngleSlot(type: string, angle: string) {
        const slot = this.getGarmentSlot(type);
        return slot ? slot.angles.find(item => item.key === angle) : null;
    }

    public isGarmentSectionExpanded(type: string) {
        return !!this.expandedGarmentTypes[type];
    }

    public async toggleGarmentSection(type: string) {
        if (this.generating) return;
        if (!this.garmentSlots.some(slot => slot.key === type)) return;

        this.expandedGarmentTypes[type] = !this.expandedGarmentTypes[type];
        await this.service.render();
    }

    public getGarmentPreview(type: string, angle: string) {
        const item = this.getGarmentAngleSlot(type, angle);
        return item ? item.preview : '';
    }

    public getGarmentSectionLabel(type: string) {
        const slot = this.getGarmentSlot(type);
        if (!slot) return '미등록';

        const count = slot.angles.filter(item => !!item.preview).length;
        return count ? `${count}/4 등록` : '미등록';
    }

    public get garmentSelectionLabel() {
        const count = this.getActiveAngles().length;
        return count ? `${count}/4 각도 등록` : '미등록';
    }

    public get genderSelectionLabel() {
        const option = this.genderOptions.find(item => item.key === this.selectedGender);
        return option ? option.label : '여성';
    }

    public get activeResultItems() {
        return this.getActiveAngles().map(view => {
            const result = this.resultItems.find(item => item.key === view.key) || {};
            return {
                key: view.key,
                label: view.label,
                garmentLabel: this.getAngleGarmentLabel(view.key),
                resultUrl: result.resultUrl || '',
                resultMode: result.resultMode || '',
                statusText: result.statusText || '',
                loading: !!result.loading,
                error: !!result.error
            };
        });
    }

    public isUploadDisabled(type: string, angle: string) {
        return !!this.getGarmentPreview(type, angle);
    }

    public async selectGender(gender: string) {
        if (this.generating || gender === this.selectedGender) return;
        if (!this.genderOptions.some(item => item.key === gender)) return;

        this.getActiveAngles().forEach(view => {
            this.invalidateGeneration(view.key);
        });

        this.selectedGender = gender;
        this.clearResult();
        await this.service.render();
    }

    private clearResult(angle?: string) {
        if (!angle) {
            this.resultItems = [];
            return;
        }
        this.resultItems = this.resultItems.filter(item => item.key !== angle);
    }

    private invalidateGeneration(angle: string) {
        this.generationVersions[angle] = (this.generationVersions[angle] || 0) + 1;
        return this.generationVersions[angle];
    }

    private isCurrentGeneration(angle: string, version: number) {
        return this.generationVersions[angle] === version;
    }

    private beginGeneration() {
        this.activeGenerations += 1;
        this.generating = this.activeGenerations > 0;
    }

    private async endGeneration() {
        this.activeGenerations = Math.max(0, this.activeGenerations - 1);
        this.generating = this.activeGenerations > 0;
        await this.service.render();
    }

    private clearSlot(item: any) {
        if (!item) return;
        if (item.objectUrl) URL.revokeObjectURL(item.objectUrl);
        item.name = '';
        item.preview = '';
        item.file = null;
        item.objectUrl = '';
    }

    private getActiveAngles() {
        return this.mannequinViews.filter(view => {
            return this.garmentSlots.some(slot => !!this.getGarmentPreview(slot.key, view.key));
        });
    }

    private getAngleGarmentTypes(angle: string) {
        return this.garmentSlots
            .filter(slot => !!this.getGarmentPreview(slot.key, angle))
            .map(slot => slot.key);
    }

    public getAngleGarmentLabel(angle: string) {
        const labels = this.garmentSlots
            .filter(slot => !!this.getGarmentPreview(slot.key, angle))
            .map(slot => slot.label);
        return labels.length ? labels.join(' + ') : '미등록';
    }

    private getAngleGarmentFile(type: string, angle: string) {
        const item = this.getGarmentAngleSlot(type, angle);
        return item ? item.file : null;
    }

    private extractResultImageValue(value: any): string {
        if (!value) return '';
        if (Array.isArray(value)) {
            for (const item of value) {
                const text = this.extractResultImageValue(item);
                if (text) return text;
            }
            return '';
        }
        if (typeof value === 'object') {
            const keys = ['url', 'src', 'href', 'path', 'file', 'image_url', 'image', 'data', 'value'];
            for (const key of keys) {
                if (value[key] === value) continue;
                const text = this.extractResultImageValue(value[key]);
                if (text) return text;
            }
            return '';
        }
        return String(value || '').trim();
    }

    private normalizeResultImageUrl(value: any, mime: string = 'image/png') {
        let text = this.extractResultImageValue(value)
            .replace(/^['"]+|['"]+$/g, '')
            .replace(/&amp;/g, '&')
            .trim();
        if (!text) return '';

        const duplicatedAbsoluteUrl = text.match(/^https?:\/\/.+?(https?:\/\/.+)$/i);
        if (duplicatedAbsoluteUrl) {
            text = duplicatedAbsoluteUrl[1];
        }

        if (text === '[object Object]' || text === '[object Array]') return '';
        if (text.startsWith('data:') || text.startsWith('blob:')) return text;
        if (text.startsWith('http://') || text.startsWith('https://')) return text;
        if (text.startsWith('//')) return `${window.location.protocol}${text}`;

        const compact = text.replace(/\s+/g, '');
        // Raw JPEG base64 often starts with /9j, so check base64 before absolute-path handling.
        if (compact.length > 128 && /^[a-z0-9+/]+={0,2}$/i.test(compact)) {
            return `data:${mime || 'image/png'};base64,${compact}`;
        }

        if (text.startsWith('/')) return text;
        if (/^[a-z0-9.-]+\.[a-z]{2,}(?::\d+)?\//i.test(text)) return `https://${text}`;
        if (/^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(text)) return `/${text}`;
        if (text.indexOf('/') >= 0) return text;
        if (/\.(png|jpe?g|webp|gif)(\?.*)?$/i.test(text)) return `/${text}`;
        return '';
    }

    private getResultImageUrl(item: any) {
        const mime = item?.mime || 'image/png';
        const candidates = [
            item?.image,
            item?.url,
            item?.image_url,
            item?.src,
            item?.href,
            item?.path
        ];
        for (const candidate of candidates) {
            const resultUrl = this.normalizeResultImageUrl(candidate, mime);
            if (resultUrl) return resultUrl;
        }
        return '';
    }

    private normalizeUploadResponse(res: any) {
        if (typeof res !== 'string') return res || {};
        try {
            return JSON.parse(res);
        } catch (e) {
            return {
                code: 0,
                data: {
                    message: res
                }
            };
        }
    }

    private getResponseMessage(res: any, fallback: string = '이미지 생성 실패') {
        return res?.data?.message || res?.message || fallback;
    }

    private getResultDownloadExtension(resultUrl: string) {
        const match = String(resultUrl || '').match(/^data:image\/([a-z0-9.+-]+);/i);
        if (!match) return 'png';

        const subtype = match[1].toLowerCase();
        if (subtype === 'jpeg') return 'jpg';
        if (subtype === 'svg+xml') return 'svg';
        return subtype.replace(/[^a-z0-9]+/g, '') || 'png';
    }

    private sanitizeDownloadPart(value: string, fallback: string) {
        const text = String(value || fallback || '이미지');
        const sanitized = text
            .replace(/[\\/:*?"<>|]+/g, '-')
            .replace(/\s*\+\s*/g, '-')
            .replace(/\s+/g, '')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');
        return sanitized || fallback || '이미지';
    }

    private getResultDownloadName(result: any) {
        const gender = this.sanitizeDownloadPart(this.genderSelectionLabel, '성별');
        const angle = this.sanitizeDownloadPart(result?.label || '결과', '결과');
        const garment = this.sanitizeDownloadPart(result?.garmentLabel || '의류', '의류');
        const extension = this.getResultDownloadExtension(result?.resultUrl || '');
        return `finestyle-${gender}-다각도피팅-${angle}-${garment}.${extension}`;
    }

    public downloadResult(result: any) {
        const resultUrl = String(result?.resultUrl || '');
        if (!resultUrl || result?.loading) return;

        const link = document.createElement('a');
        link.href = resultUrl;
        link.download = this.getResultDownloadName(result);
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    private setResultItem(angle: string, updates: any) {
        const view = this.getAngleView(angle);
        if (!view) return;

        const index = this.resultItems.findIndex(item => item.key === angle);
        const base = index >= 0 ? this.resultItems[index] : {
            key: view.key,
            label: view.label,
            resultUrl: '',
            resultMode: '',
            statusText: '',
            loading: false,
            error: false
        };
        const next = Object.assign({}, base, updates, {
            key: view.key,
            label: view.label
        });
        const items = this.resultItems.slice();
        if (index >= 0) {
            items[index] = next;
        } else {
            items.push(next);
        }
        this.resultItems = items;
    }

    private async optimizeImageFile(file: File): Promise<File> {
        const maxSize = 1024;
        const recompressThreshold = 1024 * 1024;
        if (!file.type || file.type.indexOf('image/') !== 0) return file;

        return await new Promise((resolve) => {
            const image = new Image();
            const objectUrl = URL.createObjectURL(file);
            let settled = false;
            const finish = (nextFile: File) => {
                if (settled) return;
                settled = true;
                URL.revokeObjectURL(objectUrl);
                resolve(nextFile);
            };

            image.onload = () => {
                const width = image.naturalWidth || image.width;
                const height = image.naturalHeight || image.height;
                const scale = Math.min(1, maxSize / Math.max(width, height));
                const shouldResize = scale < 1;
                const shouldRecompress = !!file.size && file.size > recompressThreshold;
                if (!width || !height || (!shouldResize && !shouldRecompress)) {
                    finish(file);
                    return;
                }

                const canvas = document.createElement('canvas');
                canvas.width = Math.round(width * scale);
                canvas.height = Math.round(height * scale);
                const context = canvas.getContext('2d');
                if (!context) {
                    finish(file);
                    return;
                }

                context.drawImage(image, 0, 0, canvas.width, canvas.height);
                const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
                const extension = outputType === 'image/png' ? '.png' : '.jpg';
                const basename = file.name.replace(/\.[^.]+$/, '') || 'garment';
                canvas.toBlob((blob) => {
                    if (!blob || blob.size >= file.size) {
                        finish(file);
                        return;
                    }
                    finish(new File([blob], `${basename}${extension}`, {
                        type: outputType,
                        lastModified: file.lastModified
                    }));
                }, outputType, 0.90);
            };
            image.onerror = () => {
                finish(file);
            };
            image.src = objectUrl;
        });
    }

    private getBackgroundAssetUrl() {
        const gender = this.selectedGender === 'male' ? 'male' : 'female';
        return `/assets/mannequin/background/${gender}-full-background.jpg?v=20260601-background-force`;
    }

    private loadCanvasImage(src: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error('이미지를 불러오지 못했습니다.'));
            image.src = src;
        });
    }

    private drawCoverImage(context: CanvasRenderingContext2D, image: HTMLImageElement, width: number, height: number) {
        const sourceWidth = image.naturalWidth || image.width;
        const sourceHeight = image.naturalHeight || image.height;
        if (!sourceWidth || !sourceHeight) return;

        let sx = 0;
        let sy = 0;
        let sw = sourceWidth;
        let sh = sourceHeight;
        const sourceRatio = sourceWidth / sourceHeight;
        const targetRatio = width / height;
        if (sourceRatio > targetRatio) {
            sw = sourceHeight * targetRatio;
            sx = (sourceWidth - sw) / 2;
        } else if (sourceRatio < targetRatio) {
            sh = sourceWidth / targetRatio;
            sy = (sourceHeight - sh) / 2;
        }
        context.drawImage(image, sx, sy, sw, sh, 0, 0, width, height);
    }

    private getSingleGarmentScope(garmentTypes: any) {
        const rawTypes = Array.isArray(garmentTypes)
            ? garmentTypes
            : String(garmentTypes || '').split(',');
        const selected: string[] = [];
        rawTypes.forEach((value: any) => {
            const key = String(value || '').trim().toLowerCase();
            if (key && selected.indexOf(key) < 0) selected.push(key);
        });
        if (selected.length === 1 && (selected[0] === 'upper' || selected[0] === 'lower')) {
            return selected[0];
        }
        return '';
    }

    private async applySingleGarmentScopeFramingUrl(sourceUrl: string, garmentTypes: any, framedScope: any = ''): Promise<string> {
        const scope = this.getSingleGarmentScope(garmentTypes);
        if (!sourceUrl || !scope || String(framedScope || '').toLowerCase() === scope) return sourceUrl;

        try {
            const image = await this.loadCanvasImage(sourceUrl);
            const sourceWidth = image.naturalWidth || image.width;
            const sourceHeight = image.naturalHeight || image.height;
            if (!sourceWidth || !sourceHeight) return sourceUrl;

            const targetWidth = this.resultImageWidth;
            const targetHeight = this.resultImageHeight;
            const targetRatio = targetWidth / targetHeight;
            const topRatio = scope === 'upper' ? 0 : 0.28;
            const heightRatio = 0.72;
            let cropHeight = Math.max(1, Math.round(sourceHeight * heightRatio));
            let cropWidth = Math.max(1, Math.round(cropHeight * targetRatio));
            if (cropWidth > sourceWidth) {
                cropWidth = sourceWidth;
                cropHeight = Math.max(1, Math.round(cropWidth / targetRatio));
            }

            let sx = Math.round((sourceWidth - cropWidth) / 2);
            let sy = Math.round(sourceHeight * topRatio);
            if (sx < 0) sx = 0;
            if (sx + cropWidth > sourceWidth) sx = Math.max(0, sourceWidth - cropWidth);
            if (sy < 0) sy = 0;
            if (sy + cropHeight > sourceHeight) sy = Math.max(0, sourceHeight - cropHeight);

            const canvas = document.createElement('canvas');
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            const context = canvas.getContext('2d');
            if (!context) return sourceUrl;
            context.drawImage(image, sx, sy, cropWidth, cropHeight, 0, 0, targetWidth, targetHeight);
            return canvas.toDataURL('image/png');
        } catch (e) {
            return sourceUrl;
        }
    }

    private buildBackgroundMask(data: Uint8ClampedArray, width: number, height: number) {
        const total = width * height;
        const like = new Uint8Array(total);
        const samples = [0, width - 1, (height - 1) * width, total - 1];
        let bgR = 0;
        let bgG = 0;
        let bgB = 0;
        samples.forEach(index => {
            const offset = index * 4;
            bgR += data[offset];
            bgG += data[offset + 1];
            bgB += data[offset + 2];
        });
        bgR = Math.round(bgR / samples.length);
        bgG = Math.round(bgG / samples.length);
        bgB = Math.round(bgB / samples.length);

        for (let index = 0; index < total; index += 1) {
            const offset = index * 4;
            const red = data[offset];
            const green = data[offset + 1];
            const blue = data[offset + 2];
            const channelMax = Math.max(red, green, blue);
            const channelMin = Math.min(red, green, blue);
            const luma = (red * 0.299) + (green * 0.587) + (blue * 0.114);
            const nearCorner = Math.abs(red - bgR) <= 42
                && Math.abs(green - bgG) <= 42
                && Math.abs(blue - bgB) <= 42
                && (Math.abs(red - bgR) + Math.abs(green - bgG) + Math.abs(blue - bgB)) <= 94;
            const lightStudioGray = luma >= 214
                && (channelMax - channelMin) <= 42
                && Math.abs(red - green) <= 24
                && blue >= green - 8;
            like[index] = nearCorner || lightStudioGray ? 1 : 0;
        }

        const visited = new Uint8Array(total);
        const mask = new Uint8Array(total);
        const queue = new Int32Array(total);
        let head = 0;
        let tail = 0;
        const enqueue = (index: number) => {
            if (index < 0 || index >= total || visited[index] || !like[index]) return;
            visited[index] = 1;
            mask[index] = 255;
            queue[tail] = index;
            tail += 1;
        };

        for (let x = 0; x < width; x += 1) {
            enqueue(x);
            enqueue((height - 1) * width + x);
        }
        for (let y = 0; y < height; y += 1) {
            enqueue(y * width);
            enqueue(y * width + width - 1);
        }

        while (head < tail) {
            const index = queue[head];
            head += 1;
            const x = index % width;
            if (x > 0) enqueue(index - 1);
            if (x < width - 1) enqueue(index + 1);
            if (index >= width) enqueue(index - width);
            if (index < total - width) enqueue(index + width);
        }

        return mask;
    }

    private buildSubjectMask(width: number, height: number) {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        const mask = new Uint8Array(width * height);
        if (!context) return mask;

        const cx = width / 2;
        const gender = this.selectedGender === 'male' ? 'male' : 'female';
        const shoulderHalf = width * (gender === 'male' ? 0.24 : 0.20);
        const waistHalf = width * (gender === 'male' ? 0.16 : 0.13);
        const hipHalf = width * (gender === 'male' ? 0.17 : 0.19);
        const armHalf = width * (gender === 'male' ? 0.075 : 0.065);
        const y = (value: number) => height * value;

        context.fillStyle = '#fff';
        context.beginPath();
        context.ellipse(cx, y(0.135), width * 0.085, height * 0.090, 0, 0, Math.PI * 2);
        context.fill();
        context.beginPath();
        context.moveTo(cx - shoulderHalf, y(0.195));
        context.lineTo(cx + shoulderHalf, y(0.195));
        context.lineTo(cx + waistHalf, y(0.510));
        context.lineTo(cx + hipHalf, y(0.665));
        context.lineTo(cx - hipHalf, y(0.665));
        context.lineTo(cx - waistHalf, y(0.510));
        context.closePath();
        context.fill();
        context.fillRect(cx - shoulderHalf - armHalf, y(0.220), armHalf * 2, height * 0.460);
        context.fillRect(cx + shoulderHalf - armHalf, y(0.220), armHalf * 2, height * 0.460);
        context.fillRect(cx - width * 0.125, y(0.615), width * 0.100, height * 0.360);
        context.fillRect(cx + width * 0.025, y(0.615), width * 0.100, height * 0.360);

        const alpha = context.getImageData(0, 0, width, height).data;
        for (let index = 0; index < mask.length; index += 1) {
            mask[index] = alpha[index * 4 + 3] ? 255 : 0;
        }
        return mask;
    }

    private shouldApplyGeneratedBackground(sourceData: Uint8ClampedArray, backgroundData: Uint8ClampedArray, width: number, height: number) {
        const points = [
            0,
            width - 1,
            (height - 1) * width,
            width * height - 1,
            Math.floor(width / 2),
            (height - 1) * width + Math.floor(width / 2)
        ];
        let alphaTotal = 0;
        let lumaTotal = 0;
        let chromaTotal = 0;
        let diffTotal = 0;
        points.forEach(index => {
            const offset = index * 4;
            const red = sourceData[offset];
            const green = sourceData[offset + 1];
            const blue = sourceData[offset + 2];
            alphaTotal += sourceData[offset + 3];
            lumaTotal += (red * 0.299) + (green * 0.587) + (blue * 0.114);
            chromaTotal += Math.max(red, green, blue) - Math.min(red, green, blue);
            diffTotal += Math.abs(red - backgroundData[offset])
                + Math.abs(green - backgroundData[offset + 1])
                + Math.abs(blue - backgroundData[offset + 2]);
        });

        const count = Math.max(1, points.length);
        const averageAlpha = alphaTotal / count;
        const averageLuma = lumaTotal / count;
        const averageChroma = chromaTotal / count;
        const averageChannelDiff = diffTotal / (count * 3);
        if (averageAlpha < 245) return true;
        if (averageChannelDiff <= 18) return false;
        return averageLuma >= 204 && averageChroma <= 42;
    }

    private async applyGeneratedBackgroundUrl(sourceUrl: string): Promise<string> {
        try {
            const [source, background] = await Promise.all([
                this.loadCanvasImage(sourceUrl),
                this.loadCanvasImage(this.getBackgroundAssetUrl())
            ]);
            const width = this.resultImageWidth;
            const height = this.resultImageHeight;
            if (!width || !height) return sourceUrl;

            const sourceCanvas = document.createElement('canvas');
            sourceCanvas.width = width;
            sourceCanvas.height = height;
            const sourceContext = sourceCanvas.getContext('2d');
            if (!sourceContext) return sourceUrl;
            this.drawCoverImage(sourceContext, source, width, height);
            const sourceImage = sourceContext.getImageData(0, 0, width, height);

            const backgroundCanvas = document.createElement('canvas');
            backgroundCanvas.width = width;
            backgroundCanvas.height = height;
            const backgroundContext = backgroundCanvas.getContext('2d');
            if (!backgroundContext) return sourceUrl;
            this.drawCoverImage(backgroundContext, background, width, height);
            const backgroundImage = backgroundContext.getImageData(0, 0, width, height);
            if (!this.shouldApplyGeneratedBackground(sourceImage.data, backgroundImage.data, width, height)) {
                return sourceCanvas.toDataURL('image/png');
            }

            const backgroundMask = this.buildBackgroundMask(sourceImage.data, width, height);
            const subjectMask = this.buildSubjectMask(width, height);
            const output = sourceContext.createImageData(width, height);
            const total = width * height;
            for (let index = 0; index < total; index += 1) {
                const offset = index * 4;
                const keep = Math.max(255 - backgroundMask[index], subjectMask[index]);
                const replace = 255 - keep;
                output.data[offset] = Math.round((sourceImage.data[offset] * keep + backgroundImage.data[offset] * replace) / 255);
                output.data[offset + 1] = Math.round((sourceImage.data[offset + 1] * keep + backgroundImage.data[offset + 1] * replace) / 255);
                output.data[offset + 2] = Math.round((sourceImage.data[offset + 2] * keep + backgroundImage.data[offset + 2] * replace) / 255);
                output.data[offset + 3] = 255;
            }
            sourceContext.putImageData(output, 0, 0);
            return sourceCanvas.toDataURL('image/png');
        } catch (e) {
            return sourceUrl;
        }
    }

    public async onGarmentChange(event: any, type: string, angle: string) {
        const input = event?.target;
        const file = input?.files?.[0];
        if (input) input.value = '';
        if (!file) return;

        const item = this.getGarmentAngleSlot(type, angle);
        if (!item) return;

        if (item.preview) {
            await this.alert("재업로드하려면 먼저 기존 의류를 삭제해주세요.");
            return;
        }

        if (!file.type || file.type.indexOf('image/') !== 0) {
            await this.alert("이미지 파일을 업로드해주세요.");
            return;
        }

        const uploadFile = await this.optimizeImageFile(file);
        this.clearSlot(item);
        const objectUrl = URL.createObjectURL(file);
        item.file = uploadFile;
        item.name = file.name;
        item.objectUrl = objectUrl;
        item.preview = objectUrl;
        this.invalidateGeneration(angle);
        this.clearResult(angle);
        await this.service.render();
    }

    public async clearGarment(type: string, angle: string) {
        const item = this.getGarmentAngleSlot(type, angle);
        if (!item) return;

        this.invalidateGeneration(angle);
        this.clearSlot(item);
        this.clearResult(angle);
        await this.service.render();
    }

    private getAngleFieldSuffix(angle: string) {
        return String(angle || '').replace(/[^a-z0-9]+/gi, '_').replace(/^_+|_+$/g, '').toLowerCase();
    }

    private isCurrentGenerationBatch(versions: any) {
        return Object.keys(versions || {}).every(angle => this.isCurrentGeneration(angle, versions[angle]));
    }

    private buildSingleAngleFormData(view: any, ignoreMannequin: boolean = this.shouldIgnoreMannequin) {
        const selectedTypes = this.getAngleGarmentTypes(view.key);
        const garmentTypes = selectedTypes.join(',');
        const fd = new FormData();
        fd.append('mannequin', view.key);
        fd.append('gender', this.selectedGender);
        fd.append('garment_types', garmentTypes);
        fd.append('ignore_mannequin', ignoreMannequin ? '1' : '0');
        selectedTypes.forEach(type => {
            const file = this.getAngleGarmentFile(type, view.key);
            if (file) fd.append(`garment_${type}`, file);
        });
        return { fd, garmentTypes };
    }

    private async uploadSingleAngleResult(view: any, ignoreMannequin: boolean = this.shouldIgnoreMannequin) {
        const data = this.buildSingleAngleFormData(view, ignoreMannequin);
        const ignoreQuery = `&ignore_mannequin=${ignoreMannequin ? '1' : '0'}`;
        const url = `${wiz.url('try_on')}?mannequin=${encodeURIComponent(view.key)}&gender=${encodeURIComponent(this.selectedGender)}&garment_types=${encodeURIComponent(data.garmentTypes)}${ignoreQuery}`;
        return this.normalizeUploadResponse(await this.service.file.upload(url, data.fd));
    }

    private async generateAnglesIndividually(
        activeAngles: any[],
        versions: any,
        fallbackMessage: string = '',
        statusText: string = '각도별 이미지 생성 중'
    ) {
        let successCount = 0;
        let failureCount = 0;
        let message = fallbackMessage;

        for (const view of activeAngles) {
            if (!this.isCurrentGeneration(view.key, versions[view.key])) continue;

            this.setResultItem(view.key, {
                statusText,
                loading: true,
                error: false,
                resultUrl: '',
                resultMode: ''
            });
            await this.service.render();

            const ignoreAttempts = this.shouldIgnoreMannequin ? [true, false] : [false];
            let handled = false;

            for (const ignoreMannequin of ignoreAttempts) {
                try {
                    const res: any = await this.uploadSingleAngleResult(view, ignoreMannequin);
                    if (!this.isCurrentGeneration(view.key, versions[view.key])) {
                        handled = true;
                        break;
                    }

                    if (res?.code === 200) {
                        const resultData = res.data || res;
                        let resultUrl = this.getResultImageUrl(resultData);
                        resultUrl = await this.applySingleGarmentScopeFramingUrl(
                            resultUrl,
                            this.getAngleGarmentTypes(view.key),
                            resultData?.scope_framed
                        );
                        if (resultUrl) {
                            this.setResultItem(view.key, {
                                resultUrl,
                                resultMode: resultData?.mode === 'ai' ? 'AI' : (resultData?.mode === 'composite' ? '합성' : '샘플'),
                                statusText: resultData?.message || '',
                                loading: false,
                                error: false
                            });
                            successCount += 1;
                            handled = true;
                            break;
                        }
                    }

                    message = this.getResponseMessage(res, message || '이미지 생성 실패');
                } catch (e) {
                    if (!this.isCurrentGeneration(view.key, versions[view.key])) {
                        handled = true;
                        break;
                    }
                    message = message || '이미지 생성 실패';
                }

                if (ignoreMannequin) {
                    this.setResultItem(view.key, {
                        statusText: '마네킹 기준 재시도 중',
                        loading: true,
                        error: false
                    });
                    await this.service.render();
                }
            }

            if (!handled) {
                this.setResultItem(view.key, {
                    statusText: message,
                    loading: false,
                    error: true
                });
                failureCount += 1;
            }
        }

        await this.service.render();
        return { successCount, failureCount, message };
    }

    private async generateActiveAngles(activeAngles: any[]) {
        let successCount = 0;
        let failureCount = 0;
        let message = '';

        const versions: any = {};
        const fd = new FormData();
        const angleKeys = activeAngles.map(view => view.key);
        fd.append('angles', angleKeys.join(','));
        fd.append('gender', this.selectedGender);
        fd.append('ignore_mannequin', this.shouldIgnoreMannequin ? '1' : '0');

        activeAngles.forEach(view => {
            versions[view.key] = this.invalidateGeneration(view.key);
            const selectedTypes = this.getAngleGarmentTypes(view.key);
            const suffix = this.getAngleFieldSuffix(view.key);
            fd.append(`garment_types_${suffix}`, selectedTypes.join(','));
            selectedTypes.forEach(type => {
                const file = this.getAngleGarmentFile(type, view.key);
                if (file) fd.append(`garment_${type}_${suffix}`, file);
            });
            this.setResultItem(view.key, {
                statusText: '다각도 이미지 생성 중',
                loading: true,
                error: false,
                resultUrl: '',
                resultMode: ''
            });
        });
        await this.service.render();

        if (activeAngles.length > 1) {
            return await this.generateAnglesIndividually(activeAngles, versions);
        }

        try {
            const url = `${wiz.url('try_on')}?angles=${encodeURIComponent(angleKeys.join(','))}&gender=${encodeURIComponent(this.selectedGender)}&ignore_mannequin=${this.shouldIgnoreMannequin ? '1' : '0'}`;
            const res: any = this.normalizeUploadResponse(await this.service.file.upload(url, fd));
            if (!this.isCurrentGenerationBatch(versions)) {
                return { successCount, failureCount, message };
            }

            if (res?.code === 200) {
                const results = Array.isArray(res.data?.results) ? res.data.results : [];
                const resultMap = results.reduce((map: any, item: any) => {
                    if (item?.key) map[item.key] = item;
                    return map;
                }, {});

                for (const view of activeAngles) {
                    const item = resultMap[view.key];
                    let resultUrl = this.getResultImageUrl(item);
                    resultUrl = await this.applySingleGarmentScopeFramingUrl(
                        resultUrl,
                        this.getAngleGarmentTypes(view.key),
                        item?.scope_framed
                    );
                    if (resultUrl) {
                        this.setResultItem(view.key, {
                            resultUrl,
                            resultMode: item.mode === 'ai' ? 'AI' : (item.mode === 'composite' ? '합성' : '샘플'),
                            statusText: item.message || res.data?.message || '',
                            loading: false,
                            error: false
                        });
                        successCount += 1;
                    } else {
                        message = this.getResponseMessage(res, message || '이미지 생성 실패');
                        this.setResultItem(view.key, {
                            statusText: message,
                            loading: false,
                            error: true
                        });
                        failureCount += 1;
                    }
                }
                await this.service.render();
                if (successCount || !failureCount) {
                    return { successCount, failureCount, message };
                }
            }

            message = this.getResponseMessage(res, message || '이미지 생성 실패');
            if (!successCount && failureCount) {
                failureCount = 0;
            }
            const fallbackResult = await this.generateAnglesIndividually(activeAngles, versions, message, '각도별 재시도 중');
            successCount += fallbackResult.successCount;
            failureCount += fallbackResult.failureCount;
            message = fallbackResult.message || message;
        } catch (e) {
            if (this.isCurrentGenerationBatch(versions)) {
                const fallbackResult = await this.generateAnglesIndividually(activeAngles, versions, message || '이미지 생성 실패', '각도별 재시도 중');
                successCount += fallbackResult.successCount;
                failureCount += fallbackResult.failureCount;
                message = fallbackResult.message || message;
            }
        }
        await this.service.render();
        return { successCount, failureCount, message };
    }

    public async tryOn() {
        if (this.generating) return;

        const activeAngles = this.getActiveAngles();
        if (!activeAngles.length) {
            await this.alert("각도별 의류 이미지를 업로드해주세요.");
            return;
        }

        this.beginGeneration();
        this.resultItems = activeAngles.map(view => ({
            key: view.key,
            label: view.label,
            resultUrl: '',
            resultMode: '',
            statusText: '대기 중',
            loading: false,
            error: false
        }));
        await this.service.render();

        let successCount = 0;
        let failureCount = 0;
        let errorMessage = '';

        try {
            const result = await this.generateActiveAngles(activeAngles);
            successCount = result.successCount;
            failureCount = result.failureCount;
            errorMessage = result.message || '';
            if (!successCount && failureCount) {
                this.resultItems = this.resultItems.map(item => item.error && result.message
                    ? Object.assign({}, item, { statusText: result.message })
                    : item);
            }
        } finally {
            await this.endGeneration();
        }

        if (!successCount && failureCount) {
            await this.alert(errorMessage || "이미지 생성에 실패했습니다.");
        }
    }
}

export default PageTryonAnglesComponent;